import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/Payment.css";

const SuccessfulPayment = () => {
  const navigate = useNavigate();
    const { state } = useLocation();
  
  return (
    <div className="payment-success-screen">
      <div className="success-icon-wrapper">
        <svg className="success-checkmark" viewBox="0 0 52 52">
          <circle className="success-checkmark-circle" cx="26" cy="26" r="25" fill="none" />
          <path className="success-checkmark-check" fill="none" d="M14 27l7 7 16-16" />
        </svg>
      </div>
      <h2 className="success-title">Payment Successful</h2>
      <p className="success-message">Thank you! Your payment has been processed successfully.</p>
      {state?.subscription === true ? 
      <button className="success-home-btn" onClick={() => navigate("/marketingScreen")}>Go to Patient Registration</button>
        : <button className="success-home-btn" onClick={() => navigate("/home")}>Return to Home</button>
        }
    </div>
  );
};

export default SuccessfulPayment;
